// IMPORTS
import {useContext, useEffect} from 'react';
import {Redirect} from 'react-router-dom';
import UserContext from '../UserContext';

export default function Logout ()
{
	const {setUser} = useContext(UserContext);
	localStorage.clear()

	// when the component mounts/ page loads, set the user state to null
	useEffect(() =>
	{
		setUser(
		{
			id: null,
			isAdmin: null,
			email: null
		})
	})

	return(
		<Redirect to= "/login"/>
		)
}